import React from 'react';
import * as S from './filters.styles';

const Stops = props => {
  const { filterType, stopsFilters, updateFilter, title } = props;
  const stops = [
    {
      text: "<b class='font16'>0</b> <span class='stopTxt'>Stops</span>",
      value: '0'
    },
    {
      text: "<b class='font16'>1</b> <span class='stopTxt'>Stop</span>",
      value: '1'
    },
    {
      text: "<b class='font16'>1+</b> <span class='stopTxt'>Stops</span>",
      value: '2'
    }
  ];
  return (
    <>
      <div className="flexCol">
        <div className="black fb font14 padB10 quicksand">{title}</div>
        <div className="dF padT10 justifyBetween flexWrap">
          {stops.map(stop => (
            <S.FltrStpLabel
              className="flexCol width50 alignItemsCenter justifyCenter "
              key={stop.value}
            >
              <S.CustCheck1
                type="checkbox"
                className="custCheck1"
                value="on"
                onClick={() => updateFilter(filterType, stop.value)}
                checked={stopsFilters.indexOf(stop.value) > -1 ? true : false}
              />
              <S.FltHpyStp
                className="dF alignItemsCenter justifyCenter fltrStops"
                dangerouslySetInnerHTML={{ __html: stop.text }}
              ></S.FltHpyStp>
            </S.FltrStpLabel>
          ))}
        </div>
      </div>
    </>
  );
};
export default Stops;
